import React from "react";
import "./add.css";

const uniquePoints = [
  { icon: "💰", name: "Cost-Efficient Hiring" },
  { icon: "📞", name: "Post-Offer Engagement" },
  { icon: "🛡️", name: "Retention-First Strategy" },
  { icon: "📢", name: "Strategic Branding" },
  { icon: "📈", name: "Scalable & Tailored Solutions" },
  { icon: "💵", name: "Minimal Hiring Costs, Maximum ROI" },
  { icon: "🤝", name: "Dual Impact – Corporates & Campuses" },
  { icon: "⚙️", name: "Tech-Enabled Precision" },
];

const BeyondPlacements = () => (
  <div className="beyond-container">
    {/* Beyond Placements Card */}
    <div className="beyond-card">
      <div className="beyond-icon">💼</div> {/* Changed icon */}
           <h2>Beyond Placements Shaping Futures</h2>
<p>
  At Career Restorer, we go beyond just securing jobs—we empower individuals to build lasting careers. 
  With practical skills, global exposure, and expert interview preparation, we help candidates succeed 
  and stand out in today’s competitive world.
</p>

    </div>

    {/* Unique Points */}
    <h2 className="section-title">What Makes Us Unique</h2>
    <div className="unique-grid">
      {uniquePoints.map((point, idx) => (
        <div className="unique-card" key={idx}>
          <div className="unique-icon">{point.icon}</div>
          <p>{point.name}</p>
        </div>
      ))}
    </div>
  </div>
);

export default BeyondPlacements;
